import styles from "./ApplicationForm.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStop } from "@fortawesome/pro-light-svg-icons"

interface ApplicationFormHeaderProps {
    icon: string
    title: string
}

const ApplicationFormHeader = ({ icon, title }: ApplicationFormHeaderProps) => {
    return (
        <div className={styles.form__header}>
            <div className={styles.form__header__icon}>
                {icon ? (
                    <img src={icon} alt="title" className={styles.form__header__icon} />
                ) : (
                    <FontAwesomeIcon className={styles.form__header__icon} icon={faStop} size="2x" />
                )}
            </div>
            <p className={styles.form__header__title}>{title}</p>
        </div>
    )
}

export default ApplicationFormHeader
